import {useState, useEffect} from 'react';
import {useInterval} from '../common/app_common.js';
import '../common/css/control_coverage_edge_manager.css';
import {Title} from '../common/component_common.js';
import * as Edges from './control_coverage_edge_manager/edges.js';
import * as Pending from './control_coverage_edge_manager/pending.js';
import * as Rejected from './control_coverage_edge_manager/rejected.js';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import {getApiReceiveEdgeCount} from '../common/fetch_api/coverage.js'

const ConnectTab = ({update, tabIndex, setTabIndex}) => {

    const [pendingCount, setPendingCount] = useState(0);
    const getPendingCount = () =>
    {
        Promise.resolve( getApiReceiveEdgeCount('pending', '') )
        .then( data => 
        {
            if(data.count != null)
            {
                setPendingCount(data.count);
            }
        });
    }

    useEffect(() => {
        getPendingCount();
    }, [update]);

    useInterval(() =>
    {
        getPendingCount();
    }, 10000 );

    return (
        <Tabs
            defaultActiveKey="Edges"
            transition={true}
            activeKey={tabIndex}
            onSelect={(k) => setTabIndex(k)}
            className="mt-3" >
            <Tab eventKey="Edges" title="Edges"/>
            <Tab eventKey="Pending" title={`Pending (${pendingCount})`}/>
            <Tab eventKey="Rejected" title="Rejected"/>
        </Tabs>
    )    
}

const PageControlCoverageEdgeManager = () => {

    const [tabIndex, setTabIndex] = useState('Edges');
    const [update, setUpdate] = useState(false);

    function runUpdate()
    {
        setUpdate(!update);
    }

    return (
        <>
            <Title title='Coverage Edge Manager'></Title>
            <ConnectTab update={update} tabIndex={tabIndex} setTabIndex={setTabIndex}></ConnectTab>
            {tabIndex==='Edges'&&<Edges.View update={update} runUpdate={runUpdate} />}
            {tabIndex==='Pending'&&<Pending.View update={update} runUpdate={runUpdate} />}
            {tabIndex==='Rejected'&&<Rejected.View update={update} runUpdate={runUpdate} />}
        </>
    )
}

export default PageControlCoverageEdgeManager;